module.exports = __webpack_public_path__ + "static/media/RN-2025-02_preview.ab2f2f8a.jpg";